
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Simular delay de autenticación
      await new Promise(resolve => setTimeout(resolve, 800));

      // Credenciales de administrador
      if (email === 'admin@viubasquet.com' && password === 'admin123') {
        // Guardar sesión de administrador
        localStorage.setItem('isAdmin', 'true');
        localStorage.setItem('adminEmail', email);
        localStorage.setItem('loginTime', Date.now().toString());
        
        // Navegar al panel de administración
        navigate('/admin');
      } else {
        setError('Email o contraseña incorrectos');
      }
    } catch (err) {
      setError('Error al iniciar sesión. Inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-white mb-2">Panel de Administración</h1>
          <p className="text-gray-400">Ingresa tus credenciales</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-4 bg-gray-800 border-none rounded-xl text-white placeholder-gray-400 focus:ring-2 focus:ring-pink-500 focus:outline-none"
              placeholder="Email"
              required
              autoComplete="email"
            />
          </div>

          <div>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-4 bg-gray-800 border-none rounded-xl text-white placeholder-gray-400 focus:ring-2 focus:ring-pink-500 focus:outline-none"
              placeholder="Contraseña"
              required
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div className="bg-red-500/20 border border-red-500/30 rounded-xl p-3">
              <div className="flex items-center">
                <i className="ri-error-warning-line text-red-400 mr-2"></i>
                <span className="text-red-400 text-sm">{error}</span>
              </div>
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 disabled:from-gray-600 disabled:to-gray-700 text-white py-4 px-4 rounded-xl font-medium transition-all duration-200 flex items-center justify-center"
          >
            {loading ? (
              <>
                <i className="ri-loader-4-line animate-spin mr-2"></i>
                Verificando...
              </>
            ) : (
              'Iniciar Sesión'
            )}
          </button>
        </form>

        <div className="mt-8 text-center">
          <button
            onClick={() => navigate('/')}
            className="text-pink-400 hover:text-pink-300 py-2 px-4 rounded-lg transition-colors flex items-center justify-center mx-auto"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
}
